import React from "react";
import { Card, Space, Typography, Tag, Button, Select } from "antd";
import { EditOutlined, DeleteOutlined } from "@ant-design/icons";
import { useSelector } from "react-redux";
import validarpermiso from "../../../../lib/utils";

const { Text } = Typography;

const CampoFormulario = ({
  campo,
  onEdit,
  onDelete,
  onOrdenChange,
  opcionesOrden,
}) => {
  const permisos = useSelector((state) => state.permisos);
  const getTipoTag = (tipo) => {
    const tipos = {
      texto: { color: "blue", text: "Texto" },
      numero: { color: "green", text: "Número" },
      select: { color: "purple", text: "Select" },
      multiple_unico: { color: "orange", text: "Selección Única" },
      multiple_multiple: { color: "cyan", text: "Selección Múltiple" },
      fecha: { color: "magenta", text: "Fecha" },
      imagen: { color: "volcano", text: "Imagen" },
    };

    const tipoInfo = tipos[tipo] || { color: "default", text: tipo };
    return <Tag color={tipoInfo.color}>{tipoInfo.text}</Tag>;
  };

  const formatOpciones = (opciones) => {
    if (!opciones) return null;
    try {
      if (typeof opciones === "string") {
        const cleanString = opciones.replace(/[{}"]/g, "");
        const pairs = cleanString.split(",").map((pair) => pair.trim());
        const values = pairs
          .filter((pair) => pair.includes(":"))
          .map((pair) => {
            const [_, value] = pair.split(":").map((s) => s.trim());
            return value;
          });
        return values.join(", ");
      }

      if (typeof opciones === "object") {
        return Object.values(opciones).join(", ");
      }

      return opciones;
    } catch (error) {
      console.error("Error al formatear opciones:", error);
      return opciones;
    }
  };

  return (
    <Card size="small" style={{ marginBottom: 8 }}>
      <Space direction="vertical" style={{ width: "100%" }}>
        <Space
          align="center"
          style={{
            justifyContent: "space-between",
            width: "100%",
          }}
        >
          <Space>
            <Text strong>{campo.label}</Text>
            {getTipoTag(campo.tipo)}
            {campo.requerido && <Tag color="red">Requerido</Tag>}
            {campo.visible_app && <Tag color="green">Visible en App</Tag>}
          </Space>
          <Space>
            {validarpermiso("campos_formulario", "update", permisos) && (
              <Button
                type="primary"
                icon={<EditOutlined />}
                onClick={() => onEdit(campo)}
              >
                Editar
              </Button>
            )}

            {validarpermiso("campos_formulario", "delete", permisos) && (
              <Button
                type="primary"
                danger
                icon={<DeleteOutlined />}
                onClick={() => onDelete(campo.id)}
              >
                Eliminar
              </Button>
            )}
          </Space>
        </Space>
        <Space align="center">
          <Text>Orden:</Text>
          <Select
            value={campo.orden}
            onChange={(value) => onOrdenChange(campo.id, value)}
            style={{ width: 120 }}
            options={opcionesOrden}
          />
        </Space>
        {campo.opciones && (
          <Text type="secondary">
            Opciones: {formatOpciones(campo.opciones)}
          </Text>
        )}
      </Space>
    </Card>
  );
};

export default CampoFormulario;
